import { render, staticRenderFns } from "./PscsPageNavbar.vue?vue&type=template&id=70292526"
import script from "./PscsPageNavbar.vue?vue&type=script&lang=js"
export * from "./PscsPageNavbar.vue?vue&type=script&lang=js"
import style0 from "./PscsPageNavbar.vue?vue&type=style&index=0&id=70292526&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports